import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators} from "@angular/forms";

@Component({
  selector: 'app-career',
  templateUrl: './career.component.html',
  styleUrls: ['./career.component.scss']
})
export class CareerComponent implements OnInit {

  contactForm: FormGroup;
  submitted: boolean;
  jobOption: any = [
    {
      id:1,
      text: 'SALES ENGINEER'
    },
    {
      id:2,
      text: 'DESIGN ENGINEER'
    },
    {
      id:3,
      text: 'PURCHASE ENGINEER'
    },
    {
      id:4,
      text: 'PLANNING ENGINEER'
    },
    {
      id:5,
      text: 'ELECTRIC ENGINEER'
    },
    {
      id:6,
      text: 'PRODUCTION ENGINEER'
    },
    {
      id:7,
      text: 'ACCOUNTANT'
    },
    {
      id:8,
      text: 'Q.C. ENGINEER'
    },
    {
      id:9,
      text: 'STORE KEEPER'
    },
    {
      id:10,
      text: 'FABRICATOR (WELDER)'
    },
    {
      id:11,
      text: 'FITTER'
    },
    {
      id:12,
      text: 'HELPER'
    },
    {
      id:13,
      text: 'PAINTER'
    }
  ]
  fileName: string = '';

  constructor(
    private fb: FormBuilder,
  ) { }

  ngOnInit() {
    this.contactForm = this.fb.group({
      first_name: ["", [Validators.required, Validators.pattern("^[a-zA-Z ]+$")]],
      last_name: ["", [Validators.required, Validators.pattern("^[a-zA-Z ]+$")]],
      email: ["", [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")]],
      phone: ["", [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      position: ["", [Validators.required]],
      cv: ["", [Validators.required]],
      brief: ["", Validators.required],
    });
  }

  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 46) {
      return false;
    }
    return true;
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.fileName = file.name;
    } else {
      this.fileName = 'Choose a File';
    }
  }

  get con(): { [key: string]: AbstractControl } {
    return this.contactForm.controls;
  }
  onSubmit(): void {
    this.submitted = true;
    if (this.contactForm.invalid) {
      return;
    }
    const data = {
      first_name: this.contactForm?.value?.first_name,
      last_name: this.contactForm?.value?.last_name,
      email: this.contactForm?.value?.email,
      phone: this.contactForm?.value?.phone,
      position: this.contactForm?.value?.position,
      brief: this.contactForm?.value?.brief,
    };

    // this.spinner.show();

    // // Make the API call with the constructed data object
    // this.apiCall.contactUsForm(data).subscribe({
    //   next: (response) => {
    //     this.spinner.hide();
    //     if (response.success) {
    //       this.common.showMessage("success", response.message);
    //       this.contactForm.reset();
    //       this.submitted = false;
    //     } else {
    //       this.common.showMessage("error", response.message);
    //     }
    //   },
    //   error: (error: any) => {
    //     this.spinner.hide();
    //     this.common.showMessage("error", error?.message);
    //   },
    // });
  }

}
